<template lang="pug">
.v-contact-list.contact-list(v-if="contactList")
	.contact-list__supertitle(v-if="contactList.supertitle" v-html="contactList.supertitle")
	.contact-list__title(v-if="contactList.title")
		v-svg-icon.contact-list__title-icon(icon="flower")
		.contact-list__title-text {{contactList.title}}
	.contact-list__items
		.contact-list__item(v-if="contactList.phone")
			.contact-list__item-title(v-if="contactList.phone.title") {{contactList.phone.title}}
			.contact-list__items-text
				template(v-for="(phoneItem, phoneItemIndex) in contactList.phone.items" :key="phoneItemIndex")
					.contact-list__item-text.flc(v-if="contactList.phone" v-html="phoneItem")
		.contact-list__item(v-if="contactList.email")
			.contact-list__item-title(v-if="contactList.email.title") {{contactList.email.title}}
			.contact-list__item-text.flc(v-if="contactList.email.text" v-html="contactList.email.text")
		.contact-list__item(v-if="contactList.address")
			.contact-list__item-title(v-if="contactList.address.title") {{contactList.address.title}}
			.contact-list__item-text.flc(v-if="contactList.address.text" v-html="contactList.address.text")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			contactList: null
		};
	},

	methods: {
		dataSet(data) {
			this.contactList = data;
		}
	}
};
</script>
